import { getDatasetAtEvent } from "react-chartjs-2";
import Input from "../../components/custom/forms/Input";
import InputSearchMini from "../../components/custom/forms/InputSearchMini";
import Eventos from "./modals/Eventos";
import { obtenerFechasExtremas } from "../../../utils/CuponUtils";

const Cupon = ({
  data,
  setData,
  onChange,
  onClick,
  navigate,
  user,
  search,
  eventos,
  modalEventos,
  setModalEventos,
  dias,
  fechas,
  setFechas,
  salas,
}) => {
  const { fechaAnterior, fechaSiguiente } = obtenerFechasExtremas(
    data.fechas_funciones
  );

  console.log(fechaAnterior);

  return (
    <div className="container-fluid py-4" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container-md" style={{ maxWidth: "1200px" }}>
        {/* Breadcrumb y Header */}
        <nav aria-label="breadcrumb" className="mb-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#" onClick={() => navigate('/dashboard/cupones')} style={{ textDecoration: "none" }}>
                Cupones
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {data.id ? `#${data.id}` : "Nuevo"}
            </li>
          </ol>
        </nav>

        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="mb-1 fw-bold" style={{ fontSize: "28px" }}>
              {data.id ? `Cupón #${data.id}` : "Nuevo Cupón"}
            </h2>
            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
              {data.id ? "Edita los detalles de tu cupón de descuento" : "Crea un nuevo cupón de descuento para tus eventos"}
            </p>
          </div>
          <div>
            <button
              className="btn btn-outline-secondary me-2"
              onClick={() => navigate('/dashboard/cupones')}
            >
              Cancelar
            </button>
            <label className="btn btn-primary px-4 mb-0">
              <svg width="16" height="16" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
              </svg>
              {data.id ? "Guardar cambios" : "Crear cupón"}
              <button
                className="d-none"
                name={data.id ? "aplicar" : "guardar"}
                onClick={(event) => onClick(event)}
              ></button>
            </label>
          </div>
        </div>

        {/* Información Básica */}
        <div className="card mb-4" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
          <div className="card-body p-4">
            <h5 className="fw-bold mb-3" style={{ fontSize: "18px" }}>
              <svg width="20" height="20" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"/>
                <path d="M2 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"/>
              </svg>
              Información Básica
            </h5>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Nombre del cupón <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="nombre"
                  value={data?.nombre}
                  onChange={onChange}
                  placeholder="Ej: Descuento Verano 2024"
                  style={{ borderRadius: "8px" }}
                />
                <small className="text-muted">Nombre descriptivo para identificar el cupón</small>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Código <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  name="codigo"
                  value={data?.codigo}
                  onChange={onChange}
                  placeholder="Ej: VERANO2024"
                  style={{ borderRadius: "8px", fontFamily: "monospace", fontWeight: "bold" }}
                />
                <small className="text-muted">Código que los usuarios ingresarán al comprar</small>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Descuento (%) <span className="text-danger">*</span>
                </label>
                <div className="input-group" style={{ borderRadius: "8px" }}>
                  <input
                    type="number"
                    className="form-control"
                    name="descuento"
                    value={data?.descuento}
                    onChange={onChange}
                    placeholder="0"
                    min="0"
                    max="100"
                    style={{ borderRadius: "8px 0 0 8px" }}
                  />
                  <span className="input-group-text" style={{ borderRadius: "0 8px 8px 0", backgroundColor: "#e9ecef" }}>
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/>
                      <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319z"/>
                    </svg>
                  </span>
                </div>
                <small className="text-muted">Porcentaje de descuento</small>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Límite de usos
                </label>
                <input
                  type="number"
                  className="form-control"
                  name="limite"
                  value={data?.limite}
                  onChange={onChange}
                  placeholder="Ilimitado"
                  min="0"
                  style={{ borderRadius: "8px" }}
                />
                <small className="text-muted">Cantidad máxima de usos (0 = ilimitado)</small>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Estado
                </label>
                <div className="d-flex align-items-center" style={{ height: "38px" }}>
                  <span className={`badge ${data?.status == 1 ? 'bg-success' : 'bg-secondary'}`} style={{ fontSize: "13px", padding: "8px 16px" }}>
                    {data?.status == 1 ? 'Activo' : 'Inactivo'}
                  </span>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Fecha de habilitación <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="fecha_habilitacion"
                  value={data?.fecha_habilitacion}
                  onChange={onChange}
                  style={{ borderRadius: "8px" }}
                />
                <small className="text-muted">Fecha desde la cual el cupón estará disponible</small>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Fecha de expiración <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="fecha_expiracion"
                  value={data?.fecha_expiracion}
                  onChange={onChange}
                  style={{ borderRadius: "8px" }}
                />
                <small className="text-muted">Fecha hasta la cual el cupón será válido</small>
              </div>
            </div>
          </div>
        </div>

        {/* Aplicación del Cupón */}
        <div className="card mb-4" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
          <div className="card-body p-4">
            <h5 className="fw-bold mb-3" style={{ fontSize: "18px" }}>
              <svg width="20" height="20" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"/>
              </svg>
              Aplicación del Cupón
            </h5>
            <p className="text-muted mb-3" style={{ fontSize: "14px" }}>
              Define dónde se puede utilizar este cupón
            </p>

            <div className="row">
              <div className="col-md-12 mb-4">
                <label className="form-label fw-medium mb-3" style={{ fontSize: "14px" }}>
                  Tipo de aplicación <span className="text-danger">*</span>
                </label>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label
                      className={`d-block p-3 border ${data?.tipo_aplicacion === 'eventos' ? 'border-primary border-2 bg-light' : 'border-secondary'}`}
                      style={{ borderRadius: "8px", cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center">
                        <input
                          type="radio"
                          name="tipo_aplicacion"
                          value="eventos"
                          checked={data?.tipo_aplicacion === 'eventos'}
                          onChange={onChange}
                          className="me-3"
                        />
                        <div className="flex-grow-1">
                          <div className="fw-bold mb-1">Eventos específicos</div>
                          <small className="text-muted">Aplica solo a eventos seleccionados</small>
                        </div>
                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
                          <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                        </svg>
                      </div>
                    </label>
                  </div>
                  <div className="col-md-6">
                    <label
                      className={`d-block p-3 border ${data?.tipo_aplicacion === 'salas' ? 'border-primary border-2 bg-light' : 'border-secondary'}`}
                      style={{ borderRadius: "8px", cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center">
                        <input
                          type="radio"
                          name="tipo_aplicacion"
                          value="salas"
                          checked={data?.tipo_aplicacion === 'salas'}
                          onChange={onChange}
                          className="me-3"
                        />
                        <div className="flex-grow-1">
                          <div className="fw-bold mb-1">Salas específicas</div>
                          <small className="text-muted">Aplica a todos los eventos de ciertas salas</small>
                        </div>
                        <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5z"/>
                        </svg>
                      </div>
                    </label>
                  </div>
                </div>
              </div>

              {data?.tipo_aplicacion == "salas" && (
                <div className="col-md-12">
                  <label className="form-label fw-medium mb-2" style={{ fontSize: "14px" }}>
                    Seleccionar salas
                  </label>
                  <div className="mb-3">
                    <InputSearchMini
                      onChange={onChange}
                      label={"Buscar salas..."}
                      name={"search-sala"}
                      type={"text"}
                      value={search}
                      onClick={onClick}
                      nameAutocomplete="añadir-sala"
                      valueAutocomplete={salas}
                      showIndex="nombre"
                      sendIndex="id"
                      validate={{}}
                    />
                  </div>

                  {data?.salas && data.salas.length > 0 && (
                    <div>
                      <p className="text-muted mb-2" style={{ fontSize: "13px" }}>
                        Salas seleccionadas ({data.salas.length})
                      </p>
                      <div className="d-flex flex-wrap gap-2">
                        {data.salas.map((sala, index) => (
                          <span
                            key={index}
                            className="badge bg-primary d-inline-flex align-items-center"
                            style={{ fontSize: "13px", padding: "8px 12px", borderRadius: "20px" }}
                          >
                            <svg width="14" height="14" className="me-1" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5z"/>
                            </svg>
                            {sala.nombre}
                            <button
                              className="btn btn-link p-0 ms-2 text-white"
                              style={{ fontSize: "16px", lineHeight: 1, textDecoration: "none" }}
                              name="quitar-sala"
                              onClick={(e) => onClick(e, index)}
                              type="button"
                            >
                              ×
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {(!data?.salas || data.salas.length === 0) && (
                    <div className="alert alert-info d-flex align-items-center" style={{ borderRadius: "8px" }}>
                      <svg width="20" height="20" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                      </svg>
                      <small>Busca y selecciona las salas donde aplicará este cupón</small>
                    </div>
                  )}
                </div>
              )}

              {data?.tipo_aplicacion == "eventos" && (
                <div className="col-md-12">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <label className="form-label fw-medium mb-0" style={{ fontSize: "14px" }}>
                      Seleccionar eventos
                    </label>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      name="ver-eventos"
                      onClick={(e) => onClick(e)}
                      type="button"
                    >
                      <svg width="14" height="14" className="me-1" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                      </svg>
                      Ver todos los eventos
                    </button>
                  </div>

                  <div className="mb-3">
                    <InputSearchMini
                      onChange={onChange}
                      label={"Buscar eventos..."}
                      name={"search"}
                      type={"text"}
                      value={search}
                      onClick={onClick}
                      nameAutocomplete="añadir-evento"
                      valueAutocomplete={eventos}
                      showIndex="nombre"
                      sendIndex="id"
                      validate={{}}
                    />
                  </div>

                  {data?.eventos && data.eventos.length > 0 && (
                    <div>
                      <p className="text-muted mb-2" style={{ fontSize: "13px" }}>
                        Eventos seleccionados ({data.eventos.length})
                      </p>
                      <div className="d-flex flex-wrap gap-2">
                        {data.eventos.map((evento, index) => (
                          <span
                            key={index}
                            className="badge bg-success d-inline-flex align-items-center"
                            style={{ fontSize: "13px", padding: "8px 12px", borderRadius: "20px" }}
                          >
                            <svg width="14" height="14" className="me-1" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                            {evento.nombre}
                            <button
                              className="btn btn-link p-0 ms-2 text-white"
                              style={{ fontSize: "16px", lineHeight: 1, textDecoration: "none" }}
                              name="quitar-evento"
                              onClick={(e) => onClick(e, index)}
                              type="button"
                            >
                              ×
                            </button>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {(!data?.eventos || data.eventos.length === 0) && (
                    <div className="alert alert-info d-flex align-items-center" style={{ borderRadius: "8px" }}>
                      <svg width="20" height="20" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                      </svg>
                      <small>Busca y selecciona los eventos donde aplicará este cupón</small>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Disponibilidad */}
        <div className="card mb-4" style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
          <div className="card-body p-4">
            <h5 className="fw-bold mb-3" style={{ fontSize: "18px" }}>
              <svg width="20" height="20" className="me-2" fill="currentColor" viewBox="0 0 16 16">
                <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
              </svg>
              Disponibilidad por Fechas
            </h5>
            <p className="text-muted mb-3" style={{ fontSize: "14px" }}>
              Configura en qué fechas y días de la semana estará disponible el cupón
            </p>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Fecha de inicio
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="fecha_inicio"
                  value={fechas.fecha_inicio ?? fechaAnterior}
                  onChange={onChange}
                  style={{ borderRadius: "8px" }}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-medium" style={{ fontSize: "14px" }}>
                  Fecha de fin
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="fecha_fin"
                  value={fechas.fecha_fin ?? fechaSiguiente}
                  onChange={onChange}
                  style={{ borderRadius: "8px" }}
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label fw-medium mb-3" style={{ fontSize: "14px" }}>
                  Días de la semana disponibles
                </label>
                <div className="d-flex flex-wrap gap-2">
                  {dias.map((dia) => (
                    <label
                      key={dia.value}
                      className={`btn ${fechas.dias.includes(dia.value) ? 'btn-primary' : 'btn-outline-secondary'}`}
                      style={{
                        borderRadius: "50%",
                        width: "48px",
                        height: "48px",
                        padding: "0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "600",
                        fontSize: "13px"
                      }}
                    >
                      {dia.name}
                      <button
                        className="d-none"
                        name="dia"
                        onClick={(e) => onClick(e, dia)}
                      ></button>
                    </label>
                  ))}
                </div>
                <small className="text-muted d-block mt-2">Selecciona los días en los que el cupón estará disponible</small>
              </div>

              {data?.fechas_funciones && data.fechas_funciones.length > 0 && (
                <div className="col-md-12">
                  <label className="form-label fw-medium mb-2" style={{ fontSize: "14px" }}>
                    Fechas generadas ({data.fechas_funciones.length})
                  </label>
                  <div className="p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px", maxHeight: "200px", overflowY: "auto" }}>
                    <div className="d-flex flex-wrap gap-2">
                      {data.fechas_funciones.map((fecha, index) => (
                        <span
                          key={index}
                          className="badge bg-light text-dark d-inline-flex align-items-center"
                          style={{ fontSize: "12px", padding: "6px 10px", border: "1px solid #dee2e6", borderRadius: "6px" }}
                        >
                          <svg width="12" height="12" className="me-1" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                          </svg>
                          {fecha.fechas[0]}
                          <button
                            className="btn btn-link p-0 ms-1 text-danger"
                            style={{ fontSize: "14px", lineHeight: 1, textDecoration: "none" }}
                            name="quitar-fecha"
                            onClick={(e) => onClick(e, index)}
                            type="button"
                          >
                            ×
                          </button>
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {modalEventos && (
        <Eventos setCupon={setData} cupon={data} setModal={setModalEventos} />
      )}
    </div>
  );
};

export default Cupon;
